// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3Y7B9","colMaxWidth":"Table_colMaxWidth__1ZDqB"};